import { defineComponent as re, computed as u, ref as a, onMounted as se, nextTick as M, onUnmounted as ue, watch as D, openBlock as R, createElementBlock as $, normalizeClass as ce, createVNode as de, unref as fe, normalizeStyle as y, createBlock as H, createCommentVNode as _ } from "vue";
import { ModuleRegistry as F, ClientSideRowModelModule as pe, CellStyleModule as me, HighlightChangesModule as he, ColumnAutoSizeModule as ge, ClientSideRowModelApiModule as ve, ColumnApiModule as Ce, PaginationModule as be, EventApiModule as Se, RenderApiModule as we, LocaleModule as Re, RowSelectionModule as ye, ValidationModule as ze, themeAlpine as W, colorSchemeDark as Be } from "./index277.js";
import I from "./index4.js";
import { AG_GRID_LOCALE_KR as xe } from "./index278.js";
import { useTheme as ke } from "@template/theme";
import { AgGridVue as Me } from "./index279.js";
/* empty css         */
const Fe = /* @__PURE__ */ re({
  __name: "BaseDataGrid",
  props: {
    columnDefs: {},
    rowData: {},
    defaultColDef: { default: () => ({}) },
    gridOptions: { default: () => ({}) },
    height: { default: "100%" },
    width: { default: "100%" },
    sortable: { type: Boolean, default: !1 },
    filterable: { type: Boolean, default: !1 },
    pagination: { type: Boolean, default: !1 },
    paginationPageSize: { default: 100 },
    paginationPageSizeSelector: { default: () => [25, 50, 100, 200] },
    suppressPaginationPanel: { type: Boolean, default: !1 },
    resizable: { type: Boolean, default: !0 },
    customColumnWidths: { type: Boolean, default: !1 },
    rowSelection: { default: "single" },
    disableRowSelection: { type: Boolean, default: !1 },
    visibleColumnCount: { default: void 0 },
    defaultSortState: {},
    hideHorizontalScrollbar: { type: Boolean, default: !1 },
    hideVerticalScrollbar: { type: Boolean, default: !1 },
    noRowsToShow: {},
    components: {},
    showPinnedColumnGradient: { type: Boolean, default: !1 },
    tightLetterSpacing: { type: Boolean, default: !0 }
  },
  emits: ["grid-ready", "sort-changed", "header-button-left-click", "header-button-right-click"],
  setup(P, { expose: E, emit: V }) {
    F.registerModules([
      pe,
      // 기본 행 모델 (필수)
      me,
      he,
      ge,
      ve,
      Ce,
      be,
      Se,
      we,
      Re,
      ye
      // 행 선택 기능
      // agAnimateShowChangeCellRenderer는 내장 렌더러로 별도 모듈 불필요
    ]), process.env.NODE_ENV !== "production" && F.registerModules([ze]);
    const e = P, G = {
      // [참고] https://github.com/ag-grid/ag-grid/blob/latest/community-modules/locale/src/ko-KR.ts
      ...xe,
      // 문구 커스터마이징을 위해서는 이 부분을 수정해주세요.
      noRowsToShow: e.noRowsToShow || "내용이 없습니다"
    }, v = V, { isDark: N } = ke(), K = u(() => N.value ? W.withPart(Be) : W), T = a(!1), C = a(null), m = a(null), z = a([]), L = (t) => t.field || t.headerName || String(t);
    se(() => {
      z.value = e.columnDefs.map(L), M(() => {
        setTimeout(() => {
          T.value = !0, M(() => {
            h.value?.$el && (C.value = new ResizeObserver(() => {
              c();
            }), C.value.observe(h.value.$el));
          });
        }, 0);
      });
    }), ue(() => {
      C.value && C.value.disconnect(), m.value && window.removeEventListener("resize", m.value);
    });
    const A = u(() => {
      const t = typeof e.height == "number" ? `${e.height}px` : e.height, o = typeof e.width == "number" ? `${e.width}px` : e.width;
      return {
        height: t,
        width: o
      };
    }), q = u(() => ({
      resizable: e.resizable,
      filter: e.filterable,
      floatingFilter: e.filterable,
      suppressMenu: !e.filterable,
      // sortable prop이 명시적으로 전달되면 그것을 사용, 아니면 기본값 false
      sortable: e.sortable !== void 0 ? e.sortable : !1,
      // 컬럼 너비 최적화 (v31+ 권장 방식)
      minWidth: 50,
      // 최소 너비 설정
      maxWidth: void 0,
      // 최대 너비 제한 해제
      // customColumnWidths가 true이면 flex를 사용하지 않고 명시적 width를 사용
      flex: e.customColumnWidths ? void 0 : 1,
      // 유연한 너비 분배 (자동으로 컨테이너 너비에 맞춤)
      autoHeaderHeight: !0,
      // 헤더 높이 자동 조정
      // 공통 값 포맷팅: null 또는 0 인 경우 '-' 표시 (개별 컬럼 valueFormatter가 있으면 해당 값이 우선)
      valueFormatter: (t) => {
        const o = t.value;
        return o === 0 || o === null ? "-" : o;
      },
      ...e.defaultColDef
    })), r = a(0), b = u(() => e.columnDefs.filter((t) => !t.pinned)), X = u(() => e.columnDefs.filter((t) => t.pinned === "left")), U = u(() => e.columnDefs.filter((t) => t.pinned === "right")), j = u(() => e.visibleColumnCount === void 0 ? b.value : b.value.slice(
      r.value,
      r.value + e.visibleColumnCount
    )), J = u(() => e.visibleColumnCount === void 0 ? !1 : r.value > 0), Q = u(() => {
      if (e.visibleColumnCount === void 0) return !1;
      const t = b.value.length;
      return r.value < t - e.visibleColumnCount;
    }), Y = u(() => {
      const t = (n) => (i) => {
        const l = i.value;
        return l === 0 || l === null ? "-" : n && typeof n == "function" ? n(i) : l;
      };
      return [
        ...X.value,
        ...j.value,
        ...U.value
      ].map((n) => {
        const i = {
          ...n,
          valueFormatter: t(n.valueFormatter)
        };
        return n.children && Array.isArray(n.children) && (i.children = n.children.map((l) => ({
          ...l,
          valueFormatter: t(l.valueFormatter)
        }))), i;
      });
    }), Z = u(() => ({
      // 기본 UI 설정
      animateRows: !0,
      enableCellTextSelection: !0,
      suppressCellFocus: !0,
      // 셀 클릭 시 포커스 테두리 제거
      suppressContextMenu: !0,
      // 우클릭 메뉴 제거
      suppressMenuHide: !0,
      // 유효하지 않은 속성 제거
      // 행 선택 설정 (체크박스 없이 행 클릭으로 선택)
      ...e.disableRowSelection ? {} : {
        rowSelection: e.rowSelection === "single" ? {
          mode: "singleRow",
          checkboxes: !1,
          headerCheckbox: !1,
          enableClickSelection: !0
        } : e.rowSelection === "multiple" ? {
          mode: "multiRow",
          checkboxes: !1,
          headerCheckbox: !1,
          enableClickSelection: !0
        } : void 0,
        suppressRowClickSelection: !1
        // 행 클릭으로 선택 허용
      },
      // 페이지네이션 설정
      pagination: e.pagination,
      paginationPageSize: e.paginationPageSize,
      paginationPageSizeSelector: e.paginationPageSizeSelector,
      suppressPaginationPanel: e.suppressPaginationPanel,
      // 레이아웃 설정
      domLayout: "normal",
      suppressHorizontalScroll: !1,
      suppressScrollOnNewData: !1,
      // 새 데이터 로드 시 스크롤 유지
      // customColumnWidths가 true일 때는 자동 크기 조정 비활성화
      suppressSizeToFit: e.customColumnWidths,
      // 명시적 컬럼 너비 사용 시 자동 크기 조정 비활성화
      // AG Grid 커스텀 한글 로케일 적용
      localeText: G,
      // v31+ 권장 설정
      suppressColumnVirtualisation: !1,
      // 컬럼 가상화 활성화
      suppressRowVirtualisation: !1,
      // 행 가상화 활성화
      enableBrowserTooltips: !0,
      // 브라우저 툴팁 활성화
      // 실시간 데이터 업데이트 최적화 설정
      suppressAnimationFrame: !0,
      // 애니메이션 프레임 억제
      suppressBrowserResizeObserver: !0,
      // 브라우저 리사이즈 옵저버 억제
      // 기본 성능 설정
      suppressLoadingOverlay: !1,
      // 로딩 오버레이 활성화
      suppressNoRowsOverlay: !1,
      // 빈 행 오버레이 활성화
      // 컬럼 이동 및 리사이징 설정
      suppressColumnMoveAnimation: !0,
      // 컬럼 이동 애니메이션 비활성화
      suppressMovableColumns: !0,
      // 컬럼 이동 기능 비활성화
      // 성능 최적화: 행 ID 추적을 위한 getRowId 함수
      getRowId: (t) => t.data && t.data.id ? t.data.id : `row-${t.node?.rowIndex ?? Math.random().toString(36).substr(2, 9)}`,
      ...e.gridOptions
    })), p = a(null), h = a(null), ee = a(null), te = a(null), B = a({}), x = a({}), g = a(!1), S = a(!1), c = () => {
      !p.value || !h.value || M(() => {
        try {
          const t = h.value?.$el;
          if (!t) return;
          const o = t.querySelector(".ag-pinned-left-header"), n = t.querySelector(".ag-pinned-right-header"), i = t.querySelector(".ag-center-cols-header"), l = t.querySelector(".ag-header");
          if (!l) return;
          const k = l.getBoundingClientRect(), d = t.getBoundingClientRect(), w = (k.height - 20) / 2, O = !!o && o.offsetWidth > 0, ae = !!n && n.offsetWidth > 0;
          if (e.visibleColumnCount !== void 0 && J.value)
            if (O && o) {
              const f = o.getBoundingClientRect().right - d.left;
              B.value = {
                position: "absolute",
                left: `${f}px`,
                top: `${w}px`,
                zIndex: "10",
                transform: "translateX(-50%)"
              }, g.value = !0;
            } else if (O)
              g.value = !1;
            else {
              let s;
              i && i.offsetWidth > 0 ? s = i.getBoundingClientRect().left - d.left : l ? s = l.getBoundingClientRect().left - d.left : s = 0, B.value = {
                position: "absolute",
                left: `${s + 22}px`,
                // 버튼 크기의 절반(10px)만큼 오른쪽으로 이동
                top: `${w}px`,
                zIndex: "10",
                transform: "translateX(-50%)"
              }, g.value = !0;
            }
          else
            g.value = !1;
          if (e.visibleColumnCount !== void 0 && Q.value)
            if (ae && n) {
              const f = n.getBoundingClientRect().left - d.left;
              x.value = {
                position: "absolute",
                left: `${f}px`,
                top: `${w}px`,
                zIndex: "10",
                transform: "translateX(-50%)"
              }, S.value = !0;
            } else {
              let s;
              i && i.offsetWidth > 0 ? s = i.getBoundingClientRect().right - d.left : l ? s = l.getBoundingClientRect().right - d.left : s = d.width, x.value = {
                position: "absolute",
                left: `${s}px`,
                top: `${w}px`,
                zIndex: "10",
                transform: "translateX(-50%)"
              }, S.value = !0;
            }
          else
            S.value = !1;
        } catch (t) {
          console.warn("버튼 위치 업데이트 실패:", t);
        }
      });
    }, oe = (t) => {
      e.visibleColumnCount !== void 0 && (r.value = Math.max(0, r.value - 1)), v("header-button-left-click", t);
    }, ne = (t) => {
      if (e.visibleColumnCount !== void 0) {
        const o = b.value.length;
        r.value = Math.min(
          o - e.visibleColumnCount,
          r.value + 1
        );
      }
      v("header-button-right-click", t);
    }, le = (t) => {
      p.value = t.api, e.customColumnWidths || setTimeout(() => {
        try {
          t.api.sizeColumnsToFit();
        } catch (n) {
          console.warn("sizeColumnsToFit 호출 실패:", n);
        }
      }, 100);
      const o = () => {
        setTimeout(() => {
          try {
            e.customColumnWidths || t.api.sizeColumnsToFit(), c();
          } catch (n) {
            console.warn("리사이즈 시 sizeColumnsToFit 호출 실패:", n);
          }
        });
      };
      m.value && window.removeEventListener("resize", m.value), window.addEventListener("resize", o), m.value = o, setTimeout(() => {
        c();
      }, 150), e.defaultSortState && e.defaultSortState.length > 0 && (t.columnApi || t.api)?.applyColumnState({
        state: e.defaultSortState,
        applyOrder: "sort"
      }), v("grid-ready", { api: t.api });
    };
    D(
      () => e.columnDefs,
      (t) => {
        const o = t.map(L), n = z.value;
        (o.length !== n.length || o.some((l, k) => l !== n[k])) && (r.value = 0), z.value = o, p.value && setTimeout(() => {
          c();
        }, 100);
      },
      { deep: !0 }
    ), D(
      () => e.visibleColumnCount,
      () => {
        r.value = 0, p.value && setTimeout(() => {
          c();
        }, 100);
      }
    ), D(
      () => r.value,
      () => {
        p.value && setTimeout(() => {
          c();
        }, 50);
      }
    );
    const ie = (t) => {
      v("sort-changed", t);
    };
    return E({
      gridApi: p
    }), (t, o) => T.value ? (R(), $("div", {
      key: 0,
      class: ce(["grid-container", {
        "grid-container--hide-horizontal-scrollbar": e.hideHorizontalScrollbar,
        "grid-container--hide-vertical-scrollbar": e.hideVerticalScrollbar,
        "grid-container--pinned-column-gradient": e.showPinnedColumnGradient,
        "grid-container--tight-letter-spacing": e.tightLetterSpacing
      }])
    }, [
      de(fe(Me), {
        ref_key: "gridRef",
        ref: h,
        theme: K.value,
        columnDefs: Y.value,
        rowData: P.rowData,
        defaultColDef: q.value,
        gridOptions: Z.value,
        components: e.components,
        headerHeight: 32,
        style: y(A.value),
        onGridReady: le,
        onSortChanged: ie,
        onColumnMoved: c,
        onColumnResized: c
      }, null, 8, ["theme", "columnDefs", "rowData", "defaultColDef", "gridOptions", "components", "style"]),
      g.value ? (R(), H(I, {
        key: 0,
        ref_key: "leftButtonRef",
        ref: ee,
        class: "header-scroll-button header-scroll-button--left",
        style: y(B.value),
        padding: "0px",
        onClick: oe,
        icon: { name: "arrow-backward-sm", size: "sm" }
      }, null, 8, ["style"])) : _("", !0),
      S.value ? (R(), H(I, {
        key: 1,
        ref_key: "rightButtonRef",
        ref: te,
        class: "header-scroll-button header-scroll-button--right",
        style: y(x.value),
        padding: "0px",
        onClick: ne,
        icon: { name: "arrow-forward-sm", size: "sm" }
      }, null, 8, ["style"])) : _("", !0)
    ], 2)) : (R(), $("div", {
      key: 1,
      class: "grid-placeholder",
      style: y(A.value)
    }, null, 4));
  }
});
export {
  Fe as default
};
